module.exports = __webpack_public_path__ + "img/pvc-full.129cf9b.svg";